'use client'

const Video = ({ height = '400', width = '1000', url, title, isMobile = false }) => {
    return (
        // <div className=''>
        <iframe
            width={width}
            height={height}
            src={url}
            title="Property Video"
            frameorder="0"
            allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen={isMobile ? false : true}>

        </iframe>
        // </div>
    )
}

export default Video